import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { MayoresdeudoresAService } from '../../../services/riesgo-credito/riesgos/mayoresdeudores-a.service';
import Swal from 'sweetalert2';
import { CommonVariables, FuncionesMes } from '../../funciones/funcionesGenerales';
import moment from 'moment';
import { messages } from '../../funciones/mensajes';
import { FormControl, FormGroup } from '@angular/forms';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { FiltersM, typesApex } from '../../../components/models';
import { companiesRiesgoCredito, companiesRiesgoCreditoAT } from '../../../shared/catalogos';
import { mayoresDeudores } from '../tablasIds';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-mayores-deudores-a',
  templateUrl: './mayores-deudores-a.component.html',
  styleUrl: './mayores-deudores-a.component.css'
})
export class MayoresDeudoresAComponent implements OnInit {
  //---------------VARIABLES GENERALES
  private color = ['#003772', '#79B2D1', '#619E44', '#EAAA39', '#E27531', '#B53755', '#004A97', '#97CCE3', '#80B266',
    '#E5B165', '#E08653', '#D3728D', '#347FB7', '#B8DCEC', '#B2DD99', '#E5C677', '#F7BC9F', '#E897B2',
    '#4E9AC7', '#CAEFFC', '#CDE2BF', '#F4E4C3', '#F4CEBD', '#FCCDE0'];
  private color2 = ['#18539A', '#E0BA26', '#EB7337', '#A24A9B', '#9CE590', '#C1809F', '#47CFD9', '#C1809F']
  public colorMulti: any = ['#2843A0', '#15A075', '#36CAE8', '#78EAD2', '#F88476', '#E23E6A'];
  public colorMono: any = ['#76C4D5'];
  @ViewChild('graficador1') graficador1: GraficadorComponent; // Zona 2: Mayores deudores
  @ViewChild('graficador2') graficador2: GraficadorComponent; // Zona 1: Saldos (Principal)
  @ViewChild('graficador3') graficador3: GraficadorComponent; // Zona 3: Proporción variables
  // ✅ AGREGAR: Variables para Gráfica 1 - Saldos (Zona Principal)
  public dataGrafica1: any[] = [];
  public labelsGrafica1: string[] = [];
  public tipoGrafica1 = typesApex.BAR;
  public ejesYGrafica1: string[] = ['%'];
  public Filters = FiltersM;


  // ✅ AGREGAR: Variables para Gráfica 2 - Mayores Deudores
  public dataGrafica2: any[] = [];
  public labelsGrafica2: string[] = [];
  public tipoGrafica2 = typesApex.BARHORIZONTAL;
  public ejesYGrafica2: string[] = ['Núm. Socio'];
  public ejesXGrafica2: string ;


  // ✅ AGREGAR: Variables para Gráfica 3 - Proporción Variables
  public dataGrafica3: any[] = [];
  public labelsGrafica3: string[] = [];
  public tipoGrafica3 = typesApex.BAR;
  public ejesYGrafica3: string[] = ['%'];

  //-------------VARIABLES OBTENCION DE PERIODOS
  private numEvaluaciones = 1;
  public idPlantilla;
  private idAdmin: string ;
  private idInst;
  public encPar: number = 0;
  public pares = [0];
  public Periodos = [];


  /*Titulos y subtitulos*/
  public subTitles = '';
  /*Filtros*/
  public cadenaEvaluacion = [];
  public prefix = '';
  public suffix = '';
  public miles = ',';
  public decimal = '.';
  public precicion = 0;
  public aling = '';
  //-------------VARIABLES DEL TABLERO
  public graftab1 = false; //mostrar el ampliar 
  public datos = [];
  public datosAT: any = [];
  public limites: any = [];
  public datosGraf: any = [];
  public datosGrafTab = [];
  public encPropVar = [];
  public dataPropVar = []
  public dataLim: any = []
  public gini = {valor: 0, concentracion: ''};

  public tituloModal = '';
  public tipoGraf = 'bar';
  public tipoGraf2 = '';
  public tipoGraf3 = 'bar';
  public hori = true;
  public encNum = 10;
  public tabMay = false;
  public tabMayPrin = true;
  public tabMayPV = false;
  public metrica = true; // true = vigentes false = vencidos
  public vencido = true;

  // Propiedades para controlar etiquetas de las gráficas
  public etiquetas1 = false; // Gráfica 1: Saldos
  public etiquetas2 = false; // Gráfica 2: Mayores Deudores
  public etiquetas3 = false; // Gráfica 3: Proporción Variables
  public modalOpen: boolean = false;

  formEvento = new FormGroup({
    monto: new FormControl(''),
  });

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private exportExcel: ExcelService,
    private cdr: ChangeDetectorRef,
    private mayoresDeudoresService: MayoresdeudoresAService
  ) {
  }

  ngOnInit() {
    this.idInst = this.cookieService.get('idInstitucion');
    this.idAdmin = companiesRiesgoCredito.find(c => c.id === this.idInst)?.idAdmin ?? '';
    var instAT = companiesRiesgoCreditoAT.find(c => c.id === this.idInst);
    if (instAT) {
      this.idPlantilla = Number(instAT.idPlantilla);
      this.getEvaluacion();
      this.encPar = this.pares[0];
    } else {
      setTimeout(() => {
        var nombre = companiesRiesgoCredito.find(c => Number(c.id) === this.idInst).name;
        messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
      }, 500)
    }
  }
  ///----------FUNCIONES OBTENCION DE PERIODOS 
  //obtencion de periodos
  private async getEvaluacion() {
    try {
      const data = await this.mayoresDeudoresService.getPeriodosAT(this.idPlantilla);
      var datanuevo = data.evaluaciones;
      this.ordenamientoDataEvaluacion([].concat(datanuevo));
    } catch (err) {
      messages.errorMessageGraph(err)
    }
  }
  private ordenamientoDataEvaluacion(datos) {
    const info = CommonVariables.obtenerPeriodos(datos, this.numEvaluaciones);
    this.Periodos = info.periodos;
    for (const an of this.Periodos) {
      if (an.anio < 2023) {
        an.utilizable = false;
      }
    }
    this.obtenerDataEvaluacion();
  }

  /* Obtención de periodos */
  private obtenerDataEvaluacion() {
    this.cadenaEvaluacion = [];
    this.subTitles = "";
    var tot = 0;
    for (var i = this.Periodos.length - 1; i >= 0; i--) {
      for (var j = this.Periodos[i].series.length - 1; j >= 0; j--) {
        if (this.Periodos[i].series[j].check || (tot > 0 && tot < 12)) {
          this.cadenaEvaluacion.push({
            evaluacion: this.Periodos[i].series[j].periodo,
            idEvaluacion: this.Periodos[i].series[j].id,
            porcentaje: '%',
            pos: this.Periodos[i].series[j].pos,
            periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes),
            mes: this.Periodos[i].series[j].nmes,
            anio: this.Periodos[i].series[j].an,
          });
          tot++;
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.idPlantilla === 7 ? this.getDatos() : this.getDatosRiesgos();
  }

  /* formateo de datos */
  public escrituraPeriodo(Periodo) {
    if (Periodo.split(' ').length === 2) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    } else if (Periodo.split(' ').length === 5) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1] + ' ' + datos[2] + ' ' + this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    }
    return Periodo;
  }

  //Filtro Periodo
  ///funcion para select periodo
  public cambioPeriodo(per) {
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.periodo === per.periodo) {
          mes.check = true;
        } else {
          mes.check = false;
        }
      }
    }
    this.obtenerDataEvaluacion();
  }

  public async getDatos() {
    var auxTabla = { vigente: [0, 0, 0, 0], vencido: [0, 0, 0, 0] };
    try {
      const data = await this.mayoresDeudoresService.getData(this.cadenaEvaluacion[0].periodo + '-01');
      const d = data.creditos_sub_calculos.ASI_03

      this.vencido = d.vencidos.length != 0 ? true : false;

      var mayoresDeudores = d.vencidos.concat(d.vigentes);
      mayoresDeudores.sort(function (a, b) {
        if (a.amortizacionCuotaSuma < b.amortizacionCuotaSuma) {
          return 1;
        }
        if (a.amortizacionCuotaSuma > b.amortizacionCuotaSuma) {
          return -1;
        }
        return 0;
      })

      this.datosGraf = JSON.parse(JSON.stringify(d.vigentes));

      this.grafica(this.tipoGraf, this.hori, 10, this.tabMay, this.metrica);

      // SUBCALCULOS TABLA PRINCIPAL
      var vig = 0, ven = 0;
      for (var i = 0; i < mayoresDeudores.length; i++) {
        if (mayoresDeudores[i].esVigente) {
          vig += mayoresDeudores[i].amortizacionCuotaSuma;
          if (i <= 9) {
            auxTabla.vigente[0] = vig;
          }
          if (i <= 24) {
            auxTabla.vigente[1] = vig;
          }
          if (i <= 49) {
            auxTabla.vigente[2] = vig;
          }
          if (i <= 99) {
            auxTabla.vigente[3] = vig;
          }
        } else {
          ven += mayoresDeudores[i].amortizacionCuotaSuma;
          if (i <= 9) {
            auxTabla.vencido[0] = ven;
          }
          if (i <= 24) {
            auxTabla.vencido[1] = ven;
          }
          if (i <= 49) {
            auxTabla.vencido[2] = ven;
          }
          if (i <= 99) {
            auxTabla.vencido[3] = ven;
          }
        }
      }
      this.getDatosAT(auxTabla);
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }

  private async getDatosRiesgos(){
    try{
      var auxTabla = { vigente: [0, 0, 0, 0], vencido: [0, 0, 0, 0] };
      // TODO IMPORTANTE poner el indice 0 para consultar el ultimo periodo 
      var data = await this.mayoresDeudoresService.getDataRiesgos(this.cadenaEvaluacion[0].anio,this.cadenaEvaluacion[0].mes,this.idAdmin);
      var mayoresDeudores = data['socios'];
      this.datosGraf = JSON.parse(JSON.stringify(data.socios));
      if(this.datosGraf.length > 0){
        this.datosGraf = this.datosGraf.map(({ idSocio, saldo, ...resto}) => ({
          ...resto,
          numeroSocio: idSocio,
          amortizacionCuotaSuma: saldo
        }));
        this.grafica(this.tipoGraf, this.hori, 10, this.tabMay, this.metrica);
        //SUBCALCULOS TABLA PRINCIPAL
        var vig = 0, ven = 0;
        for (var i = 0; i < mayoresDeudores.length; i++) {
          vig += mayoresDeudores[i].saldoVigente;
          ven += mayoresDeudores[i].saldoVencido;
          if (i <= 9) {
            auxTabla.vigente[0] = vig;
            auxTabla.vencido[0] = ven;
          }
          if (i <= 24) {
            auxTabla.vigente[1] = vig;
            auxTabla.vencido[1] = ven;
          }
          if (i <= 49) {
            auxTabla.vigente[2] = vig;
            auxTabla.vencido[2] = ven;
          }
          if (i <= 99) {
            auxTabla.vigente[3] = vig;
            auxTabla.vencido[3] = ven;
          }
        }
        auxTabla['cartera'] = data.cartera;
        this.limites = data.limites;
        this.getDatosAT(auxTabla);
      }else{
        messages.infoMessageGraph("No hay datos a procesar para la institución");
      }      
    }catch(e){
      messages.errorMessageGraph(e);
    }
  }

  public async llenadoDatos(auxTabla) {
    // LLENADO TABLA PRINCIPAL
    var div = mayoresDeudores.cuentasAT(this.idPlantilla)['div'];
    var aux = [];
    if(this.idPlantilla === 12){
      aux.push({
        descripcion: auxTabla.cartera[0]?.idSocio ?? '',
        saldo: auxTabla.cartera[0]?.saldo / auxTabla.cartera[0].creditos,
        vigente: auxTabla.cartera[0]?.saldoVigente,
        vencido: auxTabla.cartera[0]?.saldoVencido,
        total: auxTabla.cartera[0]?.saldoVigente + auxTabla.cartera[0]?.saldoVencido,
        porcen: Number.isNaN((auxTabla.cartera[0]?.saldoVigente + auxTabla.cartera[0]?.saldoVencido) / this.datosAT[div]) ? 0 : (auxTabla.cartera[0]?.saldoVigente + auxTabla.cartera[0]?.saldoVencido) / this.datosAT[div],
        mora: auxTabla.cartera[0]?.saldoVencido / (auxTabla.cartera[0]?.saldo + 0),//vencido/vigente+vencido
        id: 'vinculados',
        max: this.obtLimit('vinculados'),
        rango: ''
      });
      aux.push({
        descripcion: auxTabla.cartera[1]?.idSocio ?? '',
        saldo: auxTabla.cartera[1]?.saldo / auxTabla.cartera[1].creditos,
        vigente: auxTabla.cartera[1]?.saldoVigente,
        vencido: auxTabla.cartera[1]?.saldoVencido,
        total: auxTabla.cartera[1]?.saldoVigente + auxTabla.cartera[1]?.saldoVencido,
        porcen: Number.isNaN((auxTabla.cartera[1]?.saldoVigente + auxTabla.cartera[1]?.saldoVencido) / this.datosAT[div]) ? 0 : (auxTabla.cartera[1]?.saldoVigente + auxTabla.cartera[1]?.saldoVencido) / this.datosAT[div],
        mora: auxTabla.cartera[1]?.saldoVencido / (auxTabla.cartera[1]?.saldo + 0),//vencido/vigente+vencido
        id: 'empleados',
        max: this.obtLimit('empleados'),
        rango: ''
      });
    }
    aux.push({
      descripcion: "10 mayores deudores",
      saldo: auxTabla.vigente[0] / 10,
      vigente: auxTabla.vigente[0],
      vencido: auxTabla.vencido[0],
      total: auxTabla.vigente[0] + auxTabla.vencido[0],
      porcen: Number.isNaN((auxTabla.vigente[0] + auxTabla.vencido[0]) / this.datosAT[div]) ? 0 : (auxTabla.vigente[0] + auxTabla.vencido[0]) / this.datosAT[div],
      mora: auxTabla.vencido[0] / (auxTabla.vencido[0] + auxTabla.vigente[0]),//vencido/vigente+vencido
      id: 'mayores10Deudores',
      max: this.obtLimit('mayores10Deudores'),
      rango: ''
    })
    aux.push({
      descripcion: "25 mayores deudores",
      saldo: auxTabla.vigente[1] / 25,
      vigente: auxTabla.vigente[1],
      vencido: auxTabla.vencido[1],
      total: auxTabla.vigente[1] + auxTabla.vencido[1],
      porcen: Number.isNaN((auxTabla.vigente[1] + auxTabla.vencido[1]) / this.datosAT[div]) ? 0 : (auxTabla.vigente[1] + auxTabla.vencido[1]) / this.datosAT[div],
      mora: auxTabla.vencido[1] / (auxTabla.vencido[1] + auxTabla.vigente[1]),
      id: 'mayores20Deudores',
      max: this.obtLimit('mayores20Deudores'),
      rango: ''
    })
    aux.push({
      descripcion: "50 mayores deudores",
      saldo: auxTabla.vigente[2] / 50,
      vigente: auxTabla.vigente[2],
      vencido: auxTabla.vencido[2],
      total: auxTabla.vigente[2] + auxTabla.vencido[2],
      porcen: Number.isNaN((auxTabla.vigente[2] + auxTabla.vencido[2]) / this.datosAT[div]) ? 0 : (auxTabla.vigente[2] + auxTabla.vencido[2]) / this.datosAT[div],
      mora: auxTabla.vencido[2] / (auxTabla.vencido[2] + auxTabla.vigente[2]),
      id: 'mayores50Deudores',
      max: this.obtLimit('mayores50Deudores'),
      rango: ''
    })
    aux.push({
      descripcion: "100 mayores deudores",
      saldo: auxTabla.vigente[3] / 100,
      vigente: auxTabla.vigente[3],
      vencido: auxTabla.vencido[3],
      total: auxTabla.vigente[3] + auxTabla.vencido[3],
      porcen: Number.isNaN((auxTabla.vigente[3] + auxTabla.vencido[3]) / this.datosAT[div]) ? 0 : (auxTabla.vigente[3] + auxTabla.vencido[3]) / this.datosAT[div],
      mora: auxTabla.vencido[3] / (auxTabla.vencido[3] + auxTabla.vigente[3]),
      id: 'mayores100Deudores',
      max: this.obtLimit('mayores100Deudores'),
      rango: ''
    })
    this.datos = aux;

    //LLENADO TABLA PROPORCION A VARIABLES  
    //TODO aqui se van a ir agregando los encabezados para la tabla de proporcion de acuerdo al catalogo de cada institucion  
    switch(this.idPlantilla){
      case 7:
        this.encPropVar.push(this.datosAT.P3 - this.datosAT.P313);
        this.encPropVar.push(this.datosAT.VT007);
        this.encPropVar.push(this.datosAT.P312 - this.datosAT.P313);
        break;
      case 12: 
        this.encPropVar.push(this.datosAT.VT11);
        this.encPropVar.push(this.datosAT.VT22);
        this.encPropVar.push(this.datosAT.P502);
        break;
    } 

    var aux2 = [];
    if(this.idPlantilla === 12){
      aux2.push({
        descripcion: auxTabla.cartera[0]?.idSocio ?? '',
        patrimonio: auxTabla.cartera[0]?.saldo /this.encPropVar[0],
        cartera: auxTabla.cartera[0]?.saldo /this.encPropVar[1],
        reservas: auxTabla.cartera[0]?.saldo /this.encPropVar[2],
        
      });
      aux2.push({
        descripcion: auxTabla.cartera[1]?.idSocio ?? '',
        patrimonio: auxTabla.cartera[1]?.saldo /this.encPropVar[0],
        cartera: auxTabla.cartera[1]?.saldo /this.encPropVar[1],
        reservas: auxTabla.cartera[1]?.saldo /this.encPropVar[2],
      });
    }
    aux2.push({
      descripcion: "10 mayores deudores",
      patrimonio: this.datos[this.idPlantilla === 12?2:0].vigente / this.encPropVar[0],
      cartera: this.datos[this.idPlantilla === 12?2:0].vigente / this.encPropVar[1],
      reservas: this.datos[this.idPlantilla === 12?2:0].vigente / this.encPropVar[2],
    })
    aux2.push({
      descripcion: "25 mayores deudores",
      patrimonio: this.datos[this.idPlantilla === 12?3:1].vigente / this.encPropVar[0],
      cartera: this.datos[this.idPlantilla === 12?3:1].vigente / this.encPropVar[1],
      reservas: this.datos[this.idPlantilla === 12?3:1].vigente / this.encPropVar[2],
    })
    aux2.push({
      descripcion: "50 mayores deudores",
      patrimonio: this.datos[this.idPlantilla === 12?4:2].vigente / this.encPropVar[0],
      cartera: this.datos[this.idPlantilla === 12?4:2].vigente / this.encPropVar[1],
      reservas: this.datos[this.idPlantilla === 12?4:2].vigente / this.encPropVar[2],
    })
    aux2.push({
      descripcion: "100 mayores deudores",
      patrimonio: this.datos[this.idPlantilla === 12?5:3].vigente / this.encPropVar[0],
      cartera: this.datos[this.idPlantilla === 12?5:3].vigente / this.encPropVar[1],
      reservas: this.datos[this.idPlantilla === 12?5:3].vigente / this.encPropVar[2],
    })
    this.dataPropVar = aux2;

    // /////// FALTA LA SUMATARIA DE LOS SALDOS DE LOS CREDITOS NO HAY CONSULTA
    var aux3 = {
      saldo: this.encPropVar[0],
      pCartera: { norm: 0.15, int: 0.05 },
      monto: { norm: this.encPropVar[0] * 0.15, int: this.encPropVar[0] * (this.obtLimit('porcentajeCartera') / 100) },
      nAcre: { norm: 0, int: 0 },
      montoMax: Number(await this.obtLimit('montoMaximo')),
      nSaldos: 0,
      cuentas: []
    };
    let n = 0, i = 0, m = 0, c = [];
    for (const d of this.datosGraf) {
      if (d.amortizacionCuotaSuma > aux3.monto.norm) {
        n++;
      }
      if (d.amortizacionCuotaSuma > aux3.monto.int) {
        i++;
      }
      if (d.amortizacionCuotaSuma > aux3.montoMax) {
        m++;
        c.push(d);
      }
    }
    aux3.nAcre.norm = n;
    aux3.nAcre.int = i;
    aux3.nSaldos = m;
    aux3.cuentas = c;

    this.dataLim = aux3;
    this.prepararDatosGrafica1(); // Gráfica de saldos
    this.prepararDatosGrafica3(); // Gráfica de proporción variables
    this.idPlantilla !== 7 ? this.calculoGini() : null;
  }
  private async calculoGini(){
    try{
      const indGini = [
        {concentracion: "Adecuada", desde: 0, hasta: 0.5},
        {concentracion: "Zona de atención", desde: 0.5, hasta: 0.7},
        {concentracion: "Alta concentración", desde: 0.7, hasta: 1},
      ]
      const valorGini = await this.mayoresDeudoresService.getGini(this.idAdmin, this.cadenaEvaluacion[0].anio, this.cadenaEvaluacion[0].mes);
      for(const i of indGini){
        if(valorGini > i.desde && valorGini <= i.hasta)
          this.gini = {valor: valorGini, concentracion: i.concentracion}
      }
    }catch(e){
      messages.errorMessageGraph(e)
    }
  }
  private prepararDatosGrafica1() {
    if (!this.datos || this.datos.length === 0) {
      this.dataGrafica1 = [];
      this.labelsGrafica1 = [];
      return;
    }

    // Preparar labels
    this.labelsGrafica1 = this.datos.map(d => d.descripcion);

    // Preparar datos (porcentaje de cartera)
    const porcentajes = this.datos.map(d => Number((d.porcen * 100).toFixed(1)));

    this.dataGrafica1 = [{
      name: '%',
      data: porcentajes
    }];

    this.cdr.detectChanges();
  }
  private prepararDatosGrafica2() {
    if (!this.datosGrafTab || this.datosGrafTab.length === 0) {
      this.dataGrafica2 = [];
      this.labelsGrafica2 = [];
      return;
    }

    // Preparar labels (números de socio con formato: "1.- 123456")
    this.labelsGrafica2 = this.datosGrafTab.map((d, index) => `${index + 1}.- ${d.numeroSocio}`);

    // Preparar datos (amortización cuota suma)
    const cantidades = this.datosGrafTab.map(d => d.amortizacionCuotaSuma);

    this.dataGrafica2 = [{
      name: 'Amortización cuota',
      data: cantidades
    }];

    this.cdr.detectChanges();
  }
  private prepararDatosGrafica3() {
    if (!this.dataPropVar || this.dataPropVar.length === 0) {
      this.dataGrafica3 = [];
      this.labelsGrafica3 = [];
      return;
    }

    // Preparar labels
    this.labelsGrafica3 = this.dataPropVar.map(d => d.descripcion);

    // Preparar datos (3 series)
    const patrimonio = this.dataPropVar.map(d => Number((d.patrimonio * 100).toFixed(1)));
    const cartera = this.dataPropVar.map(d => Number((d.cartera * 100).toFixed(1)));
    const reservas = this.dataPropVar.map(d => Number((d.reservas * 100).toFixed(1)));
    
    
    this.dataGrafica3 = [
      { name: '% Patrimonio', data: patrimonio },
      { name: '% Cartera', data: cartera },
      { name: '% Reservas', data: reservas }
    ];

    this.cdr.detectChanges();
  }
  private actNAcreditados() {
    this.dataLim.montoMax = this.obtLimit('montoMaximo');
    let n = 0, i = 0, m = 0, c = [];
    for (const d of this.datosGraf) {
      if (d.amortizacionCuotaSuma > this.dataLim.monto.norm) {
        n++;
      }
      if (d.amortizacionCuotaSuma > this.dataLim.monto.int) {
        i++;
      }
      if (d.amortizacionCuotaSuma > this.dataLim.montoMax) {
        m++;
        c.push(d);
      }
    }
    this.dataLim.nAcre.norm = n;
    this.dataLim.nAcre.int = i;
    this.dataLim.nSaldos = m;
    this.dataLim.cuentas = c;
  }

  public rango(num, max) {
    max = Number(max);
    num = Number(num * 100);
    if (num <= max) {
      return "check_circle";
    } else {
      return "cancel";
    }
  }

  public async getDatosAT(auxTabla) {
    try {
      var dataAT = mayoresDeudores.cuentasAT(this.idPlantilla);
      var auxAT = {}
      //CONSULTA CUENTAS AT
      await this.agregarACuentasTotal(
        dataAT['cuentas'],
        this.cadenaEvaluacion[0].idEvaluacion,
        this.mayoresDeudoresService.getATVarP.bind(this.mayoresDeudoresService),
        "detalleEvaluacionCuenta",
        "idCuenta",
        auxAT
      );
      // CONSULTA VARIABLE TEMPORALES AT
      await this.agregarACuentasTotal(
        dataAT['varTemp'],
        this.cadenaEvaluacion[0].idEvaluacion,
        this.mayoresDeudoresService.getDetalleVarTemp.bind(this.mayoresDeudoresService),
        "detalleEvaluacionVarTemp",
        "idVarTemp",
        auxAT
      );

      this.datosAT = auxAT;
      this.idPlantilla === 7 ? this.getPropiedades(auxTabla) : this.llenadoDatos(auxTabla);
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }
  private async agregarACuentasTotal<T>(cuentas: string[],idEvaluacion: number,servicio: (idEval: number, id: string) => Promise<any>,
    detalleKey: string, idKey: string, cuentasTotal: Record<string, T>) {
    const promesas = cuentas.map(id =>
      servicio(idEvaluacion, id)
    );
    const resultados = await Promise.all(promesas);
    resultados.forEach(r => {
      const detalle = r?.[detalleKey];
      if (!detalle) return;
      const idCuenta = detalle[idKey];      
      cuentasTotal[idCuenta] = detalle.valor;
    });
  }
  private async getPropiedades(auxTabla) {
    try {
      const data = await this.mayoresDeudoresService.getPropiedades("6463f46b5a452a0012fa8f38", this.cadenaEvaluacion[0].periodo + '-01', 'no-cache');
      const aditional = data.creditos_sub_calculos.adicionales;
      let auxLimits = []
      for (const periodos of aditional) {
        const fec = moment(periodos.periodo.split('T')[0]).format('DD-MM-YYYY');
        if (JSON.stringify(periodos.propiedades).includes('ASI')) {
          auxLimits.push({
            periodo: fec,
            limites: periodos.propiedades,
          });
        }
      }
      this.limites = auxLimits;
      this.llenadoDatos(auxTabla);
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }

  //obtiene el valor del nombre de la variable que recibe 
  public obtLimit(prop, sinFor?) {    
    if(this.idPlantilla === 7){
      let auxLimits = undefined;
      for (const p of this.limites) {
        const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
        if (moment(p.periodo).isSameOrBefore(pS)) {
          auxLimits = p;
          if (auxLimits === undefined) {
            auxLimits = p;
          } else if (moment(auxLimits.periodo).isBefore(moment(p.periodo))) {
            auxLimits = p;
          }
        }
      }
      if (auxLimits !== undefined && auxLimits.limites && auxLimits.limites.ASI_03 && auxLimits.limites.ASI_03['' + prop]) {
        if (sinFor === undefined) {
          return auxLimits.limites.ASI_03['' + prop].limits.max;
        } else {
          return auxLimits.limites.ASI_03['' + prop].limits.max;
        }
      } else {
        return 0;
      }
    }else{
      return this.limites.find(i => i.name === prop)?.max ?? 0;
    }
  }

  public async actualizarLimite(lim) {
    var inputValue = this.obtLimit(lim.id);
    var introdujo: any, guardo = false;

    introdujo = await Swal.fire({
      title: 'Ingresa el procentaje máximo',
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (Number(value) > 100) {
          return 'El porcentaje no puede exceder el 100%';
        }
        guardo = true;
        return '';
      }
    });

    if (guardo) {
      var aux = '';
      switch (lim.id) {
        case 0: aux = 'mayores10Deudores'; break;
        case 1: aux = 'mayores20Deudores'; break;
        case 2: aux = 'mayores50Deudores'; break;
        case 3: aux = 'mayores100Deudores'; break;
        default: break;
      }
      this.idPlantilla === 7 ? this.actLimites(lim.id, introdujo.value) : this.postLimitesRiesgos(lim, introdujo.value);
    } else {
      messages.errorMessageGraph(this.translate.instant('swal.swalNoGuardo'));
    }
  }
  public async postLimitesRiesgos(limite, valor:number){
    try{
      messages.messageSaving(this.translate.instant('swal.editandoInfo'), this.translate.instant('swal.espere'));
      //TODO IMPORTANTE ACTUALIZAR EL 1 POR 0 
      const body = {
        min: null,
        max: valor,
        anio: this.cadenaEvaluacion[0].anio,
        mes: this.cadenaEvaluacion[0].mes,
        idInstitution: this.idAdmin,      
      }
      const res = await firstValueFrom(this.mayoresDeudoresService.postLimitesRiesgos(body, limite.id));
      this.limites = this.limites.map( i => 
        i.name === limite.id
          ? {...i, max: res.max}
          : i
      );
      limite.id !== 'montoMaximo' ? this.datos.find(p => p.id === limite.id).max = res.max : this.actNAcreditados();
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    }catch(e){
      messages.errorMessageGraph(this.translate.instant('swal.swalNoGuardo'));
    }
  }
  //guarda el nuevo limite del rango, recibe el nuevo dato y el limite a actualizar (min o max)
  public actLimites(limite, valor) {
    messages.messageSaving(this.translate.instant('swal.actualizando'), this.translate.instant('swal.espere'))
    let lim = this.obtLimitJson();
    let nuevoPerido = false;
    var periodo = moment(FuncionesMes.escrituraPer(this.subTitles)).format('YYYY-MM-DD'), Json;
    if (lim !== undefined) {
      if (lim.limites.ASI_03 === undefined || lim.limites.ASI_03['' + limite] === undefined) {
        let nuevo;
        nuevo = JSON.parse('{"' + limite + '": { "limits": { "max": ' + valor + ', "min": 0}}}');
        const Json2 = Object.assign(nuevo, lim.limites.ASI_03);
        const Json3 = JSON.parse('{"ASI_03":' + JSON.stringify(Json2) + '}');
        Json = JSON.parse(JSON.stringify(lim.limites));
        Json.ASI_03 = Json3.ASI_03;
        lim.limites = Json;
      } else {
        let nuevo = JSON.parse(JSON.stringify(lim));
        nuevo.limites.ASI_03['' + limite].limits.max = Number(valor);
        Json = nuevo.limites;
        lim.limites = nuevo.limites;
      }
    } else {
      const cop = this.obtLimitJsonCopia();
      let dat;
      if (cop !== undefined) {
        dat = JSON.parse(JSON.stringify(cop));
      } else {
        dat = JSON.parse('{"limites": {"ASI_03":{"' + limite + '": { "limits": { "max": ' + valor + ', "min": 0}}}}}');
      }
      if (dat.limites.ASI_03['' + limite] === undefined) {
        let nuevo;
        nuevo = JSON.parse('{"' + limite + '": { "limits": { "max": ' + valor + ', "min": 0}}}');
        const Json2 = Object.assign(nuevo, dat.limites.ASI_03);
        const Json3 = JSON.parse('{"ASI_03":' + JSON.stringify(Json2) + '}');
        Json = JSON.parse(JSON.stringify(dat.limites));
        Json.ASI_03 = Json3.ASI_03;
      } else {
        let nuevo = JSON.parse(JSON.stringify(dat));
        nuevo.limites.ASI_03['' + limite].limits.max = Number(valor);
        Json = nuevo.limites;
      }
      nuevoPerido = true;
    }

    this.limites = [];
    this.mayoresDeudoresService.setLimites(periodo, Json, "6463f46b5a452a0012fa8f38").then(async respuesta => {
      if (nuevoPerido) {
        this.limites.push({
          periodo: moment(periodo + '-01', "YYYY-MM-DD").format("DD-MM-YYYY"),
          limites: Json
        });
      }
      // this.mensajeSucces('swal.swalGuardo');
      try {
        const data = await this.mayoresDeudoresService.getPropiedades("6463f46b5a452a0012fa8f38", this.cadenaEvaluacion[0].periodo + '-01', 'no-cache');
        const aditional = data.creditos_sub_calculos.adicionales;
        let auxLimits = []
        for (const periodos of aditional) {
          const fec = moment(periodos.periodo.split('T')[0]).format('DD-MM-YYYY');
          const ex = auxLimits.filter(l => l.periodo === fec);
          if (ex.length === 0 && periodos.propiedades.ASI_03) {
            auxLimits.push({
              periodo: fec,
              limites: periodos.propiedades,
            });
          }
        }
        this.limites = [...auxLimits];
        messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        this.dataLim.monto.int = this.encPropVar[0] * (this.obtLimit('porcentajeCartera') / 100)
        this.actNAcreditados();
      } catch (error) {
        messages.errorMessageGraph(error);
      }
    });
  }
  //obtiene el arreglo de limites del periodo
  public obtLimitJson() {
    for (const p of this.limites) {
      const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if (moment(p.periodo).isSame(pS)) {
        return p;
      }
    }
    return undefined;
  }
  public obtLimitJsonCopia() {
    let exis = undefined;
    for (const p of this.limites) {
      const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if (moment(p.periodo).isSameOrBefore(pS)) {
        if (exis === undefined) {
          exis = p;
        } else if (moment(exis.periodo).isSameOrBefore(moment(p.periodo))) {
          exis = p;
        }
      }
    }
    return exis;
  }

  public grafica(tipo, eje, num, tab, met) {
    this.encNum = num;
    this.tipoGraf = tipo;
    this.hori = eje;
    this.datosGrafTab = [];
    this.tabMay = tab;
    this.metrica = met;
    if (!tab && num == 100) {
      this.encNum = 10;
      num = 10;
    }

    // Preparar datos para la tabla/gráfica
    if (num != 100) {
      if (num >= this.datosGraf.length) {
        this.datosGrafTab = [...this.datosGraf];
      } else {
        this.datosGrafTab = this.datosGraf.slice(0, num);
      }
    } else {
      this.datosGrafTab = [...this.datosGraf];
    }

    // Determinar tipo de gráfica y actualizar ejes según orientación
    if (tipo === 'area') {
      this.tipoGrafica2 = typesApex.AREA;
        this.ejesXGrafica2 = 'Núm. Socio'; // Eje X = Núm. Socio
        this.ejesYGrafica2 = ['Amortización cuota']; // Eje Y = Cantidad

    } else {
      if (eje) {
        // Gráfica HORIZONTAL
        this.tipoGrafica2 = typesApex.BARHORIZONTAL;
        this.ejesXGrafica2 = this.translate.instant('credito.mayores.tit6'+this.idPlantilla); // Eje X = Cantidad
        this.ejesYGrafica2 = ['Núm. Socio']; // Eje Y = Núm. Socio
      } else {
        // Gráfica VERTICAL
        this.tipoGrafica2 = typesApex.BAR;
        this.ejesXGrafica2 = 'Núm. Socio'; // Eje X = Núm. Socio
        this.ejesYGrafica2 = ['Amortización cuota']; // Eje Y = Cantidad
      }
    }

    // Preparar datos para el graficador
    if (!this.tabMay) {
      this.prepararDatosGrafica2();
    }
  }
  public graficaStack(tipo, tab) {
    this.tabMayPrin = tab;
    this.tipoGraf2 = tipo;

    // Determinar tipo de gráfica
    if (tipo === 'area') {
      this.tipoGrafica1 = typesApex.AREA;
    } else if (tipo === 'line') {
      this.tipoGrafica1 = typesApex.LINE;
    } else {
      this.tipoGrafica1 = typesApex.BAR;
    }

    // Preparar datos para el graficador
    if (!this.tabMayPrin) {
      this.prepararDatosGrafica1();
    }
  }
  public graficaProp(tipo, tab) {
    this.tabMayPV = tab;
    this.tipoGraf3 = tipo;

    // Determinar tipo de gráfica
    if (tipo === 'area') {
      this.tipoGrafica3 = typesApex.AREA;
    } else if (tipo === 'line') {
      this.tipoGrafica3 = typesApex.LINE;
    } else {
      this.tipoGrafica3 = typesApex.BAR;
    }

    // Preparar datos para el graficador
    if (!this.tabMayPV) {
      this.prepararDatosGrafica3();
    }
  }
  //ampliar la grafica 
  public ampliarGraf(grafZona) {
    this.tituloModal = grafZona;
    this.modalOpen = true;
  }
  openModal() {
    this.formEvento.controls['monto'].setValue(this.obtLimit('montoMaximo', 'ss'));
    document.getElementById("porcentajes")!.style.display = "block";
  }
  //Cerrar modal ampliar grafica

  public closeModal() {
    document.getElementById("ampliar")!.style.display = "none";
  }
  public closeModal2(fin) {
    document.getElementById("porcentajes")!.style.display = "none";
    if (fin) {
      messages.errorMessageGraph(this.translate.instant('swal.swalNoGuardo'));
    }
  }

  //detecta el click fuera del modal y cierra 
  public clickFuera(event, fin?) {
    if (event.target === document.getElementById("ampliar")) {
      this.closeModal();
    }
    if (event.target === document.getElementById("porcentajes")) {
      this.closeModal2(fin);
    }
    if (event.target === document.getElementById("cuentas")) {
      this.closeModalCuentas();
    }
  }

  //exportar grafica en imagen 
  public exportarGrafica(id: string, nombre: string, num: any) {
    // Construir el título completo
    const tituloCompleto = num + this.translate.instant(nombre) + " " + this.escrituraPeriodo(this.subTitles);

    // Determinar qué graficador usar según el ID del contenedor
    let graficador: GraficadorComponent | undefined;
    let zona: number = 0;

    switch (id) {
      case 'grafContPrin': // Gráfica Principal - Saldos (Zona 1)
        graficador = this.graficador2;
        zona = 1;
        break;

      case 'grafCont': // Mayores Deudores (Zona 2)
        graficador = this.graficador1;
        zona = 2;
        break;

      case 'grafContPV': // Proporción Variables (Zona 3)
        graficador = this.graficador3;
        zona = 3;
        break;

      case 'ampliar': // Modal ampliado
        // Determinar qué gráfica está ampliada según tituloModal
        if (this.tituloModal === 'p') {
          graficador = this.graficador2; // Saldos
          zona = 4;
        } else if (this.tituloModal === 'm') {
          graficador = this.graficador1; // Mayores deudores
          zona = 5;
        } else if (this.tituloModal === 'pv') {
          graficador = this.graficador3; // Proporción variables
          zona = 6;
        }
        break;

      default:
        messages.errorMessageGraph('Error: ID de gráfica no válido');
        return;
    }

    // Configurar los títulos para el exportador
    const titulos = {
      titulo: tituloCompleto,
      subtitulo: this.escrituraPeriodo(this.subTitles),
      nombreArch: tituloCompleto.replace(/\s/g, '_')
    };

    // Exportar si el graficador existe
    if (graficador && zona > 0) {
      graficador.exportImg(zona, titulos);
    } else {
      messages.errorMessageGraph('No se puede exportar la imagen. Asegúrese de que la gráfica esté visible (no en modo tabla).');
    }
  }

  public exportMayoresDeu() {
    var tit = [], datos = [];
    var alineacion = this.idPlantilla === 7 
      ? [Aligment.CENTER, Aligment.CENTER,Aligment.CENTER, Aligment.RIGHT]
      : [Aligment.CENTER, Aligment.CENTER,Aligment.CENTER, Aligment.RIGHT, Aligment.RIGHT, Aligment.RIGHT];
    var formato = this.idPlantilla === 7
      ? [FormatText.NUMBER,FormatText.TEXT,FormatText.TEXT,FormatText.NUMBER]
      : [FormatText.NUMBER,FormatText.TEXT,FormatText.NUMBER,FormatText.NUMBER,FormatText.NUMBER,FormatText.NUMBER];
    tit.push(this.translate.instant('credito.mayores.tit3'));
    tit.push(this.translate.instant("credito.mayores.tit4"));
    if(this.idPlantilla === 7){tit.push(this.translate.instant("credito.mayores.tit5"))}
    if(this.idPlantilla === 12){
      tit.push(this.translate.instant("credito.mayores.tit7"));
      tit.push(this.translate.instant("credito.mayores.enc3"));
      tit.push(this.translate.instant("credito.mayores.enc4"));
    }
    tit.push(this.translate.instant("credito.mayores.tit6"+this.idPlantilla));

    let j = 1;
    for (const i of this.datosGrafTab) {
      var aux = [];
      aux.push(j);
      aux.push(i.numeroSocio);
      if(this.idPlantilla === 7)aux.push(i.numeroCredito);
      if(this.idPlantilla === 12 ){
        aux.push(i.creditos);
        aux.push(i.saldoVigente);
        aux.push(i.saldoVencido);
      }
      aux.push(i.amortizacionCuotaSuma);
      datos.push(aux)
      j++;
    }

    let metr = this.metrica ? this.translate.instant('credito.mayores.metrica1') : this.translate.instant('credito.mayores.metrica2')
    let titHoja = this.encNum + " " + this.translate.instant('credito.mayores.tituloGraf') + " | " + metr + " | " + this.escrituraPeriodo(this.subTitles);
    let nombreArchivo = this.encNum + ' ' + this.translate.instant('credito.mayores.tituloGraf') + ' ' + this.escrituraPeriodo(this.subTitles)
    this.exportExcel.generateExcel(titHoja, tit, datos, nombreArchivo, alineacion, formato);
    messages.succesMessageGraph(this.translate.instant('swal.descargaExi'));
  }

  public exportCartera() {
    //Ahora se llama Saldos
    var tit = [], enc = [], datos = [], rango = [];

    tit.push('');
    tit.push('');
    tit.push(this.translate.instant('credito.mayores.tit1'));
    tit.push('');
    tit.push('');
    tit.push('');
    tit.push('');
    tit.push(this.translate.instant('credito.mayores.tit2'));

    enc.push(this.translate.instant('credito.mayores.enc1'));
    enc.push(this.translate.instant("credito.mayores.enc2"));
    enc.push(this.translate.instant("credito.mayores.enc3"));
    enc.push(this.translate.instant("credito.mayores.enc4"));
    enc.push(this.translate.instant('credito.mayores.enc5'));
    enc.push(this.translate.instant("credito.mayores.enc6"));
    enc.push(this.translate.instant("credito.mayores.enc7"));
    enc.push(this.translate.instant("credito.mayores.enc8"));
    enc.push(this.translate.instant("credito.mayores.enc9"));

    let j = 1;
    for (const i of this.datos) {
      var aux = [];
      aux.push(i.descripcion);
      aux.push(i.saldo);
      aux.push(i.vigente);
      aux.push(i.vencido);
      aux.push(i.total);
      aux.push(i.porcen/100);
      aux.push(i.mora);
      aux.push(i.max);
      aux.push(i.rango);
      rango.push(this.rango(i.porcen, i.max))
      datos.push(aux)
      j++;
    }



    let titHoja = this.translate.instant('credito.mayores.tituloTabla') + " | " + this.escrituraPeriodo(this.subTitles);
    this.exportExcel.excelCreditoCarteraMay(titHoja, tit, enc, datos, this.translate.instant('credito.mayores.tituloTabla') + ' ' + this.escrituraPeriodo(this.subTitles), rango);
  }
  public exportPV() {
    var tit = [], enc = [], datos = [];

    tit.push('');
    tit.push(this.translate.instant('credito.mayores.enc10'));
    tit.push(this.translate.instant('credito.mayores.enc11'));
    tit.push(this.translate.instant('credito.mayores.enc12'));

    enc.push(this.translate.instant('credito.mayores.enc1'));
    enc.push(this.encPropVar[0]);
    enc.push(this.encPropVar[1]);
    enc.push(this.encPropVar[2]);

    for (const i of this.dataPropVar) {
      var aux = [];
      aux.push(i.descripcion);
      aux.push(i.patrimonio);
      aux.push(i.cartera);
      aux.push(i.reservas);
      datos.push(aux)
    }



    let titHoja = this.translate.instant('credito.mayores.titulotab1') + " | " + this.escrituraPeriodo(this.subTitles);
    this.exportExcel.excelCreditoPropVar(titHoja, tit, enc, datos, this.translate.instant('credito.mayores.titulotab1') + ' ' + this.escrituraPeriodo(this.subTitles));
  }
  public exportLim() {
    var tit = [], datos = [], aux = [], alineacion = [Aligment.CENTER, Aligment.RIGHT], formato = [FormatText.TEXT,FormatText.NUMBER] ;
    let titHoja = this.translate.instant('credito.mayores.titulotab2') + " | " + this.escrituraPeriodo(this.subTitles);
    let nombreArch = this.translate.instant('credito.mayores.titulotab2') + ' ' + this.escrituraPeriodo(this.subTitles);
    if(this.idPlantilla === 7){
      tit.push(this.translate.instant('credito.mayores.enc1'));
      tit.push(this.translate.instant('credito.mayores.enc13'));
      tit.push(this.translate.instant('credito.mayores.enc14'));
      
      aux.push(this.translate.instant('credito.mayores.descLim1'));
      aux.push(this.dataLim.saldo);
      aux.push("");
      datos.push(aux);
      aux = [];
      aux.push(this.translate.instant('credito.mayores.desLim2'));
      aux.push(this.dataLim.pCartera.norm);
      aux.push(this.dataLim.pCartera.int);
      datos.push(aux);
      aux = [];
      aux.push(this.translate.instant('credito.mayores.desLim3'));
      aux.push(this.dataLim.monto.norm);
      aux.push(this.dataLim.monto.int);
      datos.push(aux);
      aux = [];
      aux.push(this.translate.instant('credito.mayores.desLim4'));
      aux.push(this.dataLim.nAcre.norm);
      aux.push(this.dataLim.nAcre.int);
      datos.push(aux);
      aux = [];
      aux.push(this.translate.instant('credito.mayores.desLim5'));
      aux.push("");
      aux.push(this.dataLim.montoMax);
      datos.push(aux);
      aux = [];
      aux.push(this.translate.instant('credito.mayores.desLim6'));
      aux.push("");
      aux.push(this.dataLim.nSaldos);
      datos.push(aux);
      this.exportExcel.excelCreditoLimites(titHoja, tit, datos, nombreArch);
    }else{
      tit.push(this.translate.instant('credito.mayores.enc1'));
      tit.push(this.translate.instant('credito.mayores.enc15'));

      aux.push(this.translate.instant('credito.mayores.desLim3'));
      aux.push(this.dataLim.montoMax);
      datos.push(aux);
      aux = [];
      aux.push(this.translate.instant('credito.mayores.desLim4'));
      aux.push(this.dataLim.nSaldos);
      datos.push(aux);
      aux = [];
      aux.push(this.translate.instant('credito.mayores.desLim5'));
      aux.push(this.dataLim.cuentas?.[0]?.amortizacionCuotaSuma ?? 0);
      datos.push(aux);
      this.exportExcel.generateExcel(titHoja, tit, datos, nombreArch, alineacion, formato);
    }
    messages.succesMessageGraph(this.translate.instant('swal.descargaExi'));
  }
  public async actualizarCart() {
    var inputValue = this.obtLimit('porcentajeCartera'), introdujo: any, guardo = false;

    introdujo = await Swal.fire({
      title: 'Ingrese el procentaje de cartera máxima por acreditado',
      text: "",
      input: 'number',
      inputValue: Number(inputValue),
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (Number(value) > 100 && this.idPlantilla === 7) {
          return 'El porcentaje no puede exceder el 100%';
        }
        guardo = true;
        this.dataLim.pCartera.int = Number(value) / 100;
        return '';
      }
    });

    if (guardo) {
      this.actLimites('porcentajeCartera', introdujo.value);
    } else {
      messages.errorMessageGraph(this.translate.instant('swal.swalNoGuardo'));
    }
  }
  public actMontoMax() {
    let value = Number(this.formEvento.controls['monto'].value);
    this.idPlantilla === 7 ? this.actLimites('montoMaximo', value) : this.postLimitesRiesgos({id:'montoMaximo'}, value);
    this.closeModal2(false);
  }
  public mostrarCuentas() {
    document.getElementById("cuentas")!.style.display = "block";
  }
  public closeModalCuentas() {
    document.getElementById("cuentas")!.style.display = "none";
  }
  public exportarCuentas() {
    var titulos = [
      this.translate.instant('credito.mayores.tit3'),
      this.translate.instant('credito.mayores.tablaCuentasTitulo1'),
      this.translate.instant('credito.mayores.tablaCuentasTitulo2'),
      this.translate.instant('credito.mayores.tablaCuentasTitulo3')
    ]
    var alineacion = [
      Aligment.CENTER,
      Aligment.CENTER,
      Aligment.CENTER,
      Aligment.RIGHT
    ]
    var formato = [
      FormatText.NUMBER,
      FormatText.NUMBER,
      FormatText.NUMBER,
      FormatText.NUMBER,
    ]

    const data = [];
    var i = 1
    for (const d of this.dataLim.cuentas) {
      var aux = [];

      aux.push(i);
      aux.push(d.numeroSocio);
      aux.push(d.numeroCredito);
      aux.push(d.amortizacionCuotaSuma);
      i++;
      data.push(aux);
    }
    var tituloHoja = this.translate.instant('credito.mayores.titTab');
    var nombreArch = this.translate.instant('credito.mayores.nombreArch') + ' ' + this.escrituraPeriodo(this.subTitles);
    this.exportExcel.generateExcel(tituloHoja, titulos, data, nombreArch, alineacion, formato);
  }
  public showLabels(){
    switch(this.tituloModal){
      case 'prin':
        return this.etiquetas1;
      case 'may':
        return this.etiquetas2;
      case 'pv':
        return this.etiquetas3;
      default:
        return false;
    }
  }
  public changeLabels(){
    switch(this.tituloModal){
      case 'prin':
        this.etiquetas1 = !this.etiquetas1;
        break;
      case 'may':
        this.etiquetas2 = !this.etiquetas2;
        break;
      case 'pv':
        this.etiquetas3 = !this.etiquetas3;
        break;
    }
  }
  public exportarModal(){
    switch(this.tituloModal){
      case 'prin':
        this.exportarGrafica('ampliar', 'credito.mayores.tituloTabla', '');
        break;
      case 'may':
        this.exportarGrafica('ampliar', 'credito.mayores.tituloGraf', this.encNum + ' ');
        break;
      case 'pv':
        this.exportarGrafica('ampliar', 'credito.mayores.titulotab1', '');
        break;
    }
  }
}

